export default {
  subscriptionTitle: {
    en: '{productsPerPeriod, select, 1 {One fragrance} 2 {Two fragrances} 3 {Three fragrances}} per month',
  },
  forFirstMonth: {
    en: 'for the first month',
  },
  oneBottle: {
    en: '0.27 oz (8 mL) bottle of your choosing.',
  },
  renews: {
    en: 'Renews at {price}.',
  },
  saveLong: {
    en: 'Save {percent} (or roughly {save}) per month with this plan.',
  },
  choose: {
    en: 'Choose {count, plural, one {# fragrance} other {# fragrances}}',
  },
  mostPopularLabel: {
    en: 'Most popular',
  },
}
